import React, { useEffect, useState } from 'react'
import { getDeviceSize } from '../../exports/InteractiveUtils';
import { numberFormat, priceFormat, formatSchemeName } from '../../exports/UtilFunctions';

const DEVICE_SIZE = getDeviceSize();

const FamilyPortfolioTable = ({transaction}) => {
    const [transactions,setTransaction] = useState([])

    useEffect(()=>{
        setTransaction(transaction.slice(0,-1))
    },[])
    return (
        <div className="family-stocks-table">
            {!transactions || transactions.length === 0 ? (
                <></>
            ) : (
                <>
                    {DEVICE_SIZE === "S" ? (
                        <>
                    {transaction.slice(0, -1).map((h, index) => {
                      return (
                        <PortfolioCard
                          key={index}
                          data={h}
                        //   handleBuy={handleBuy}
                        //   handleSell={handleSell}
                        />
                      );
                    })}
                        </>
                    ) : (
                        <>
                            <table className='family-mf-table'>
                                <thead>
                                    <tr>
                                        <td className="scheme-name">Scheme Name</td>
                                        <td className="">Folio No</td>
                                        <td className="">Units</td>
                                        {/* <td className="inv-cost">Inv. Cost (Avg. Cost)</td> */}
                                        <td className="inv-value">Inv. Value (Curr. Nav)</td>
                                        <td className="profit-loss">Profit/ Loss</td>
                                        <td className="">Weight</td>
                                        <td className="">Tot. Ret./XIRR</td>
                                        {/* <td className="">XIRR</td> */}
                                        <td>Change</td>
                                        <td className="hover-td"></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactions.map((h, index) => {
                                        const isTotalRow = h.scheme_name === "TOTAL";
                                        return (
                                            <tr key={index} className={isTotalRow ? "total-row" : "yes_hover"}>
                                                <td className="body-scheme-name">{isTotalRow ? "" : h.scheme_name}</td>
                                                <td>{isTotalRow ? "" : h.folio_no}</td>
                                                <td>{isTotalRow ? "" : numberFormat(h.units)}</td>
                                                <td className={isTotalRow ? "total-col" : ""}>
                                                    {priceFormat(h.investment_value)} {isTotalRow ? "" : `(${priceFormat(h.current_nav)})`}<br />
                                                    <span style={{ fontSize: "10px" }}>
                                                        {priceFormat(h.investment_cost)} {isTotalRow ? "" : `(${priceFormat(h.avg_cost)})`}
                                                    </span>
                                                </td>
                                                {/* <td className={isTotalRow ? "total-col" : ""}>
                                                                   {priceFormat(h.investment_value)} {isTotalRow ? "" : `(${priceFormat(h.current_nav)})`}
                                                                 </td> */}
                                                <td className={isTotalRow ? "total-col" : ""}>{priceFormat(h.profit_loss)}</td>
                                                <td className={isTotalRow ? "total-col" : ""}>{numberFormat(h.weight)}%</td>
                                                <td className={`${h.total_return >= 0 ? "positive" : "negative"} ${isTotalRow ? "total-col" : ""}`}>
                                                    {numberFormat(h.total_return)}%<br />
                                                    {numberFormat(h.xirr)}%
                                                </td>
                                
                                                <td className={h.navChange >= 0 ? "positive" : "negative"}>
                                                    {isTotalRow ? "" : `${numberFormat(h.navChange) + "%" || "--"}`}
                                                </td>

                                                {/* {!isTotalRow && (
                                                                   <div className="hover-container">
                                                                     <div
                                                                       className="hover-btn hover-input-btn"
                                                                       onClick={() => handleFirstDate(account_token,h.isin,h.folio_no)}
                                                                     >
                                                                       <img
                                                                         src="/static/media/select-graph.4c225a2b.svg"
                                                                         alt="hoverbutton"
                                                                         width="20px"
                                                                         height="10px"
                                                                       />
                                                                     </div>
                                                                   </div>
                                                                 )} */}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </>
                    )}
                </>
            )}
        </div>
    )
}

function PortfolioCard({ data }) {
  const {
    folio_no,
    current_nav,
    navChange,
    category,
    scheme_name,
    investment_cost,
    avg_cost,
    investment_value,
    profit_loss,
    units,
    xirr,
    total_return,
  } = data;

  const [schemeName, setSchemeName] = useState(null);

  useEffect(() => {
    if (scheme_name) {
      setSchemeName(formatSchemeName(scheme_name));
    }
  }, [scheme_name]);

  return (
    <div className="mf-watchlist-card">
      <div className="mfwc-config">
        <div className="mfwc-config-row">
          <p>{schemeName && <p className="name">{schemeName}</p>}</p>
          <p className="value">
            {priceFormat(investment_value)}
          </p>
        </div>
        <div className="mfwc-config-row">
          <p className="category">{category}</p>
          <p>Folio:&nbsp;{folio_no}</p>
        </div>
        <div className="mfwc-config-row">
          <p>
            <span>
              {numberFormat(units)} @ ({priceFormat(avg_cost)})
            </span>
          </p>
          <p>
            {priceFormat(current_nav)}&nbsp;&nbsp;
            <span className={navChange > 0 ? "positive" : "negative"}>
              ({numberFormat(navChange)}%)
            </span>
          </p>
        </div>
        <div className="mfwc-config-row">
          <p>{priceFormat(investment_cost)}&nbsp;</p>
          <p>
            <span className={profit_loss > 0 ? "positive" : "negative"}>
              {priceFormat(profit_loss)}&nbsp;<sub>PnL</sub>
            </span>
            &nbsp;&nbsp;
            <span className={total_return >= 0 ? "positive" : "negative"}>
              {numberFormat(total_return)}%&nbsp;<sub>TR</sub>
            </span>
            &nbsp;&nbsp;
            <span className={xirr >= 0 ? "positive" : "negative"}>
              {numberFormat(xirr)}%&nbsp;<sub>XIRR</sub>
            </span>
            &nbsp;&nbsp;
          </p>
        </div>
      </div>
    </div>
  );
}



export default FamilyPortfolioTable
